import create from 'zustand';
export type NavItem = {
    label: string;
    icon?: string;
    iconOnHover?: string;
    breadcrumb?: any[];
    isHidden?: boolean;
    link: string;
    children: NavItem[];
  };
interface MenuStore {
    items: NavItem[];
    loading: boolean;
    error: string | null;
    fetchMenu: () => Promise<void>;
    reset: () => void;
}

const useMenuStore = create<MenuStore>((set, get) => {
    const fetchMenu = async () => {
        const state = get(); 
        console.log(state,"Menu Store");
        if (state?.items?.length > 0) return;

       
        set({ error: null });
        try {
            const response = await fetch('/menu/menu.json');
            const data = await response.json();
            set({ items: data, loading: false });
        } catch (error:any) {
            set({ loading: false, error: error.message });
        } finally {
           
        }
    };

    fetchMenu(); // Call fetchMenu without await

    return {
        items: [], // Initialize with an empty array
        loading: true, // Set loading to true initially
        error: null, // Initialize error as null
        fetchMenu,
        reset: () => {
            set({ items: [], loading: false, error: null });
        }
    };
});

export default useMenuStore;